import { APICore } from "helpers/api/apiCore";
import { unmaskPiiFieldByUrl } from "helpers/piiUnmask";
import { FilterMetadata } from "redux/types";
import config from "../../../config";
import {  reviewFIFORepayment } from "./types";

const api = new APICore();

function fetchRepaymentsApi(params: FilterMetadata) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayments-request`;
  return api.get(`${baseUrl}`, params);
}

function fetchRepaymentsAdjusmentEntriesApi(params: FilterMetadata) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-settlement-entries`;
  return api.get(`${baseUrl}`, params);
}

function createRepaymentRequestSettleApi(params: any) {
  console.log(params);

  const apiData = {
    repaymentRequestExternalId: params?.repaymentRequest?.externalId ? params?.repaymentRequest?.externalId : params?.externalId,
    typePayload: null,
    repaymentRequestActionType: "SettleInstruments",
    makerRemarks: "Request Send"
  };

  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-request-actions/settle`;
  return api.create(`${baseUrl}`, apiData);
}

function createRepaymentRequestSettleManuallyApi(params: any) {
  const apiData = {
    programExternalId: params?.programId?.externalId ? params?.programId?.externalId : "",
    customerRelationExternalId: params?.buyerSellerId?.externalId ? params?.buyerSellerId?.externalId : "",
    requestId: params?.requestId ? params?.requestId : ""
  };

  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayments-request/repayment/settle-manually`;
  return api.create(`${baseUrl}`, apiData);
}

function fetchRepaymentsAdjusmentEntrieApi(params: any) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-settlement-entries/${params}`;
  return api.get(`${baseUrl}`, {});
}

function fetchRepaymentApi(params: any) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayments-request/${params}`;
  return api.get(`${baseUrl}`, params);
}

function createRepaymentApi(params: any) {
  let formData = new FormData();

  let apiData: any = {
    programme_external_id: params?.programme ? params?.programme : "",
    borrrower_external_id: params?.borrowerExternalId ? params?.borrowerExternalId : "",
    exposure_on: params?.exposureOn ? params?.exposureOn : "",
    repayment_account_number: params?.repaymentBankAccountNumber || params?.loanAccountNumber || "",
    repayment_request_strategy: params?.repaymentRequestStrategy ?  params?.repaymentRequestStrategy :"",
  };

  if (params.exposureOn === "Anchor") {
    apiData.customer_relation_external_id = null;
  }

  if (params.exposureOn === "CounterParty") {
    apiData.customer_relation_external_id = params?.customerRelationExternalId ? params?.customerRelationExternalId : "";
  }

  // Add batch instruments to the form data
  formData.append("file", params?.batchInstrumnets[0]);

  // Append each key-value pair from apiData to the formData object
  Object.keys(apiData).forEach((key) => {
    formData.append(key, apiData[key]);
  });

  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayments-request/repayment/file`;

  return api.create(baseUrl, formData);
}

function uploadRepaymentSettlemtnApi(params: any) {
  let formData = new FormData();
  formData.append("file", params?.batchInstrumnets[0]);

  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayments-request-instrument-settlement/settleInstruments/file`;
  return api.create(baseUrl, formData);
}

function fetchRepaymentVersionApi(params: any) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-request-actions/${params}/action/versions`;
  return api.get(`${baseUrl}`, {});
}

function approveRepaymentApi(params: any) {
  let remarks = {
    checkerRemarks: params.checkerRemarks.trim()
  };

  let externalId = params.externalId;
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-request-actions/${externalId}/approve`;
  return api.updatePatch(`${baseUrl}`, remarks);
}
function rejectRepaymentApi(params: any) {
  let remarks = {
    checkerRemarks: params.checkerRemarks.trim()
  };

  let externalId = params.externalId;
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-request-actions/${externalId}/reject`;
  return api.updatePatch(`${baseUrl}`, remarks);
}

function reviewFIFORepaymentRequestApi(params: reviewFIFORepayment) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-request-actions/${params.versionRecordId}/reviewFifoRepayment`;
  return api.updatePatch(`${baseUrl}`, params.reviewPayload);
}

function fetchRepaymentAuditActionsApi(params:FilterMetadata){
  const baseUrl=`${config.REPAYMENT_BASE_URL}/action-audit`;
  return api.get(`${baseUrl}`,params)
}

function unmaskRepaymentRequestPiiFieldApi(recordId: string, fieldName: string) {
  return unmaskPiiFieldByUrl(`${config.REPAYMENT_BASE_URL}/repayments-request/${recordId}/pii/unmask`, fieldName);
}

export {
  unmaskRepaymentRequestPiiFieldApi,
  fetchRepaymentsApi,
  fetchRepaymentApi,
  createRepaymentApi,
  fetchRepaymentVersionApi,
  approveRepaymentApi,
  rejectRepaymentApi,
  uploadRepaymentSettlemtnApi,
  fetchRepaymentsAdjusmentEntriesApi,
  fetchRepaymentsAdjusmentEntrieApi,
  createRepaymentRequestSettleApi,
  createRepaymentRequestSettleManuallyApi,
  reviewFIFORepaymentRequestApi,
  fetchRepaymentAuditActionsApi
};
